/**
 * 기존의 main vue 대응을 위한 mixin
 * 일부 기능은 역할에 따라 layout component, store, App.vue로 이관
 */

import { mainVueAxios } from '@/plugins/http'
import { checkAuthActionAccess } from '@/utils/checkAuthActionAccess'
import { APP_API_URL, initData } from '@/utils/constants'
import { formatterNum } from '@/utils/formatterNum'
import { formatterPercent } from '@/utils/formatterPercent'
import { formatterPrice } from '@/utils/formatterPrice'
import { resolveImage } from '@/utils/resolveImage'
import { util } from './utilMixin'
import { mapGetters } from 'vuex'
import { isNew } from '@/utils/isNew'

export default {
  data() {
    const code = {
      default_: [
        { label: 'O', value: true },
        { label: '', value: false },
      ],
      yn: [
        { label: 'Y', value: 'Y' },
        { label: 'N', value: 'N' },
      ],
      answeredYn: [
        { label: this.$t('답변'), value: true },
        { label: this.$t('미답변'), value: false },
      ],
      payYn: [
        { label: this.$t('결제'), value: 'Y' },
        { label: this.$t('미결제'), value: 'N' },
      ],
      cancelYn: [
        { label: this.$t('주문 취소'), value: 'Y' },
        { label: this.$t('주문'), value: 'N' },
      ],
      cancelPay: [
        { label: this.$t('결제 취소'), value: 'Y' },
        { label: this.$t('결제'), value: 'N' },
      ],
      printYn: [
        { label: this.$t('출력'), value: 'Y' },
        { label: this.$t('미출력'), value: 'N' },
      ],
      useYn: [
        { label: this.$t('사용 가능'), value: 'Y' },
        { label: this.$t('사용 불가능'), value: 'N' },
      ],
      nonLocked: [
        { label: this.$t('사용 가능'), value: 'Y' },
        { label: this.$t('잠금'), value: 'N' },
      ],
      nonExpired: [
        { label: this.$t('사용 가능'), value: 'Y' },
        { label: this.$t('만료'), value: 'N' },
      ],
      certificateNonExpired: [
        { label: this.$t('사용 가능'), value: 'Y' },
        { label: this.$t('인증 만료'), value: 'N' },
      ],
      gender: [
        { label: this.$t('남'), value: 'M' },
        { label: this.$t('여'), value: 'F' },
      ],
      method: [
        { label: 'NONE', value: 'NONE' },
        { label: 'GET', value: 'GET' },
        { label: 'POST', value: 'POST' },
        { label: 'PUT', value: 'PUT' },
        { label: 'DELETE', value: 'DELETE' },
        { label: 'PATCH', value: 'PATCH' },
      ],
    }

    return {
      APP_API_URL,
      util,
      mainVue: {
        currVue: null,
        lan: [],
        code,
        appMsg: {
          loadingMsg: this.$t('처리중 입니다...'),
          systemAlterTitle: this.$t('시스템 메세지'),
          systemAlterButton: this.$t('로그인 페이지로 돌아가기'),
          systemAlterTimeoutMsg: this.$t('연결 시간 초과 하였습니다. 다시 로그인 하십시오.'),
          systemAlterNoPermissionsMsg: this.$t('권한 부족하여 리소스에 접근 할 수 없습니다.'),
          systemBtnOk: this.$t('확인'),
          systemBtnClose: this.$t('닫기'),
        },

        // mainVue methods
        $axios: mainVueAxios,
        $message: this.$message,
        $confirm: this.$confirm,
        initWebSocket: () => {
          // 샵인샵 — 그룹 storeIds가 있으면 다중 구독 (auth 모듈 state는 { auth: {...} } 래핑)
          const auth = this.$store.state.auth.auth || {}
          const storeIds = auth.storeIds && auth.storeIds.length ? auth.storeIds : auth.storeId

          this.$webSocket.init(storeIds)
        },
        websock: {
          close: () => {
            this.$webSocket.disconnect()
          },
        },
        formatterCode: this.formatterCode,
        initData,
        formatterNum,
        formatterPercent,
        formatterPrice,
      },
    }
  },
  computed: {
    ...mapGetters({
      tableHeight: 'ui/tableHeight',
      inputHeight: 'ui/inputHeight',
    }),
  },
  watch: {
    tableHeight: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          if (!this.$refs.table) return

          this.$refs.table.doLayout()
        })
      },
    },
  },
  mounted() {
    this.currVue = this

    window.addEventListener('resize', this.setHeights)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setHeights)
  },
  updated() {
    this.$nextTick(() => {
      this.$root.$emit('resize')
    })
  },
  methods: {
    setHeights() {
      if (this.$device.tablet) {
        this.subTableHeight = 300
        this.subTableHeight2 = 260
      } else {
        const viewportHeight = document.documentElement.clientHeight

        if (viewportHeight < 800) {
          this.subTableHeight = 300
          this.subTableHeight2 = 260
        } else if (viewportHeight < 1000) {
          this.subTableHeight = 350
          this.subTableHeight2 = 310
        } else if (viewportHeight < 1200) {
          this.subTableHeight = 400
          this.subTableHeight2 = 360
        } else if (viewportHeight < 1400) {
          this.subTableHeight = 450
          this.subTableHeight2 = 410
        } else {
          this.subTableHeight = 500
          this.subTableHeight2 = 460
        }
      }
    },
    formatterCode: function (row, column, cellValue, index) {
      const code = this.mainVue.code

      if (code.hasOwnProperty(column.property)) {
        for (var i = 0, len = code[column.property].length; i < len; i++) {
          if (cellValue == code[column.property][i].value) {
            return code[column.property][i].label
          }
        }
      }

      return cellValue
    },

    resolvImage: resolveImage,
    checkAuthActionAccess,
    isNew,
  },
}
